import { ChangeDetectorRef, Component, LOCALE_ID, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { EMPTY, Subscription, switchMap } from 'rxjs';
import { SharedModule } from '../../core/shared.module';
import { AppService } from '../../service/app.service';
import { LoaderService } from '../../service/loader.service';
import { NotificationService } from '../../service/notification.service';
import { DelegheService } from '../../service/deleghe.service';
import { DelegaTimesheet, UtenteDelegabile } from '../../interfaces/delega.interface';
import { Attori } from '../../shared/enum/attori.enum';
import { MatSidenav } from '@angular/material/sidenav';
import { TabellaStoricoDelegheComponent } from '../../shared/components/tabella-storico-deleghe/tabella-storico-deleghe.component';
import { FiltroStoricoDelegheComponent } from '../../shared/components/filtro-storico-deleghe/filtro-storico-deleghe.component';
import { NuovaDelegaModalComponent } from '../../shared/components/nuova-delega-modal/nuova-delega-modal.component';
import { ConfirmationModal } from '../../shared/components/confirmationModal/confirmation.modal';
import { filtroDelegheVuoto } from '../../interfaces/filtro-deleghe.interface';
import { AnagraficaTimesheet } from '../../interfaces/timesheet.interface';
import { TimesheetService } from '../../service/timesheet.service';

@Component({
  selector: 'app-storico-deleghe',
  standalone: true,
  imports: [
    SharedModule,
    TabellaStoricoDelegheComponent,
    FiltroStoricoDelegheComponent,
  ],
  templateUrl: './storico-deleghe.component.html',
  providers: [{ provide: LOCALE_ID, useValue: 'it-IT' }],
})
export class StoricoDelegheComponent {
  constructor(
    private loader: LoaderService,
    private router: Router,
    private route: ActivatedRoute,
    private appService: AppService,
    private dialog: MatDialog,
    private delegheService: DelegheService,
    private timesheetService: TimesheetService,
    private notificationService: NotificationService,
    private cd: ChangeDetectorRef,
  ) {}

  pageSubscriptions: Subscription = new Subscription();
  componentLoaded = false;
  attore = this.appService.attore;
  attori = Attori;
  deleghe: DelegaTimesheet[] = [];
  delegheCount: number = 0;
  deleganti: UtenteDelegabile[] = [];
  delegabili: UtenteDelegabile[] = [];
  anagraficaTimesheet: AnagraficaTimesheet | null = null;
  @ViewChild('sidenav') sidenav!: MatSidenav;
  @ViewChild(TabellaStoricoDelegheComponent) tabellaComponent!: TabellaStoricoDelegheComponent;

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.deleghe = data['data'].deleghe;
      this.delegheCount = data['data'].delegheCount;
      this.deleganti = data['data'].deleganti;
      this.delegabili = data['data'].delegabili;
    });

    this.pageSubscriptions.add(
      this.timesheetService.getAnagraficaTimeSheet().subscribe((anagrafica) => {
        this.anagraficaTimesheet = anagrafica;
      })
    );

    this.cd.detectChanges();
    this.componentLoaded = true;
    this.loader.hide();
  }

  search(event: any) {
    this.sidenav.close();
    if (this.tabellaComponent) {
      this.tabellaComponent.handleSearchEvent(event);
    }
  }

  openNuovaDelega(): void {
    const dialogRef = this.dialog.open(NuovaDelegaModalComponent, {
      data: {
        deleganti: this.deleganti,
        delegabili: this.delegabili,
        idAnagraficaTimesheet: this.anagraficaTimesheet?.id,
      },
      autoFocus: false,
      disableClose: true,
      width: 'calc(100% - 30px)',
      maxWidth: '600px',
    });

    this.pageSubscriptions.add(
      dialogRef
        .afterClosed()
        .subscribe({
          next: (result) => {
            if (result) {
              this.updateData();
              this.notificationService.success(
                'Delega inserita con successo',
                5000
              );
            }
          },
        })
    );
  }

  disattivaDelega(delega: DelegaTimesheet): void {
    const dialogRef = this.dialog.open(ConfirmationModal, {
      data: {
        title: 'Conferma eliminazione',
        text: `Sei sicuro di voler eliminare la delega di ${delega.nomeDelegante} a ${delega.nomeDelegato}?`,
      },
      autoFocus: false,
      disableClose: true,
      width: 'calc(100% - 30px)',
      maxWidth: '600px',
    });

    this.pageSubscriptions.add(
      dialogRef
        .afterClosed()
        .pipe(
          switchMap((result) => {
            if (!result) {
              return EMPTY;
            }
            this.loader.show();
            return this.delegheService.disattivaDelega(delega.id);
          })
        )
        .subscribe({
          next: () => {
            this.updateData();
            this.notificationService.success(
              'Delega eliminata con successo',
              5000
            );
          },
          error: () => this.loader.hide(),
        })
    );
  }

  exportDataToExcel(): void {
    if (this.tabellaComponent) {
      this.tabellaComponent.exportDataToExcel();
    }
  }

  goToHomepage(): void {
    this.loader.show();
    this.router.navigate(['homepage']);
  }

  updateData(): void {
    this.loader.show();
    const filtro = { ...filtroDelegheVuoto, pageNumber: 1, pageSize: 10 };
    this.pageSubscriptions.add(
      this.delegheService.getStoricoDelegheCount(filtro).pipe(
        switchMap((count: number) => {
          this.delegheCount = count;
          return this.delegheService.getStoricoDeleghe(filtro);
        })
      ).subscribe({
        next: (data: DelegaTimesheet[]) => {
          this.deleghe = data;
          this.cd.detectChanges();
          if (this.tabellaComponent) {
            this.tabellaComponent.handleSearchEvent(filtroDelegheVuoto);
          }
          this.appService.get().subscribe((user: any) => {
            this.appService.user = user;
          });
        },
        complete: () => this.loader.hide(),
        error: () => this.loader.hide(),
      })
    );
  }

  ngOnDestroy(): void {
    this.pageSubscriptions.unsubscribe();
  }
}
